import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type StationeryPageInfoFragment = {
  __typename?: 'StationeryPageInfo';
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  endCursor?: string | null;
  startCursor?: string | null;
};

export type StationeryDesignGallerySummaryTemplateFragment = {
  __typename?: 'StationeryTemplate';
  id: string;
  category: Types.StationeryTemplateCategoryEnum;
  approved: boolean;
  enabled: boolean;
  name?: string | null;
  themeId: string;
  thumbnailUrl?: string | null;
  premium: boolean;
  isFavorite: boolean;
  widthInches: number;
  heightInches: number;
  hasPhoto: boolean;
};

export type CardDashboardStationeryTemplatesContainerQueryVariables = Types.Exact<{
  filter: Types.StationeryTemplateFilter;
  includeOptions?: Types.InputMaybe<Types.StationeryTemplateIncludeOptions>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  skipDigitalDesigns: Types.Scalars['Boolean'];
}>;

export type CardDashboardStationeryTemplatesContainerQuery = {
  __typename?: 'Query';
  stationeryTemplatesContainer: {
    __typename?: 'StationeryTemplateContainer';
    pagedResults: {
      __typename?: 'StationeryTemplateConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'StationeryTemplateEdge';
        cursor: any;
        node: {
          __typename?: 'StationeryTemplate';
          productIds: Array<string>;
          id: string;
          category: Types.StationeryTemplateCategoryEnum;
          approved: boolean;
          enabled: boolean;
          name?: string | null;
          themeId: string;
          thumbnailUrl?: string | null;
          premium: boolean;
          isFavorite: boolean;
          widthInches: number;
          heightInches: number;
          hasPhoto: boolean;
          themeJSON: any;
        };
      }>;
      pageInfo: { __typename?: 'StationeryPageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null; startCursor?: string | null };
    };
  };
  ecardDesigns: Array<{
    __typename?: 'Theme';
    id: string;
    themeId: string;
    name: string;
    marketingData: Array<{ __typename?: 'ThemeMarketingData'; variantThemeId?: string | null; variationType: Types.ThemeVariationType; imageUrl: string; vendor: string }>;
  }>;
};

export type CardDashboardStationeryTemplatesSummaryQueryVariables = Types.Exact<{
  filter: Types.StationeryTemplateFilter;
  includeOptions?: Types.InputMaybe<Types.StationeryTemplateIncludeOptions>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type CardDashboardStationeryTemplatesSummaryQuery = {
  __typename?: 'Query';
  stationeryTemplatesContainer: {
    __typename?: 'StationeryTemplateContainer';
    pagedResults: {
      __typename?: 'StationeryTemplateConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'StationeryTemplateEdge';
        cursor: any;
        node: {
          __typename?: 'StationeryTemplate';
          productIds: Array<string>;
          id: string;
          category: Types.StationeryTemplateCategoryEnum;
          approved: boolean;
          enabled: boolean;
          name?: string | null;
          themeId: string;
          thumbnailUrl?: string | null;
          premium: boolean;
          isFavorite: boolean;
          widthInches: number;
          heightInches: number;
          hasPhoto: boolean;
        };
      }>;
      pageInfo: { __typename?: 'StationeryPageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null; startCursor?: string | null };
    };
  };
};

export type StationeryCreateSamplePackOrderMutationVariables = Types.Exact<{
  data: Types.CreateStationerySamplePrintOrderInput;
}>;

export type StationeryCreateSamplePackOrderMutation = {
  __typename?: 'Mutation';
  createAndStartCheckoutSamplePrintOrder: { __typename?: 'StartStationeryCheckoutResponse'; checkoutUrl?: string | null };
};

export type StationeryIsEventEligibleForFreeSampleKitQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
}>;

export type StationeryIsEventEligibleForFreeSampleKitQuery = { __typename?: 'Query'; stationeryIsEventEligibleForFreeSampleKit: boolean };

export const StationeryPageInfoFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryPageInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPageInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const StationeryDesignGallerySummaryTemplateFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryDesignGallerySummaryTemplate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'widthInches' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heightInches' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPhoto' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CardDashboardStationeryTemplatesContainerDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CardDashboardStationeryTemplatesContainer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTemplateFilter' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeOptions' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTemplateIncludeOptions' } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skipDigitalDesigns' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryTemplatesContainer' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'includeOptions' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeOptions' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagedResults' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryDesignGalleryTemplate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'productIds' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryPageInfo' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'ecardDesigns' },
            name: { kind: 'Name', value: 'themes' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'skip' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'skipDigitalDesigns' } } }],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'marketingData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'variantThemeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'variationType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryPageInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPageInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryDesignGalleryTemplate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'widthInches' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heightInches' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPhoto' } },
          { kind: 'Field', name: { kind: 'Name', value: 'themeJSON' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCardDashboardStationeryTemplatesContainerQuery__
 *
 * To run a query within a React component, call `useCardDashboardStationeryTemplatesContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardDashboardStationeryTemplatesContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardDashboardStationeryTemplatesContainerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      includeOptions: // value for 'includeOptions'
 *      first: // value for 'first'
 *      skipDigitalDesigns: // value for 'skipDigitalDesigns'
 *   },
 * });
 */
export function useCardDashboardStationeryTemplatesContainerQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<CardDashboardStationeryTemplatesContainerQuery, CardDashboardStationeryTemplatesContainerQueryVariables>,
) {
  return ApolloReactHooks.useQuery<CardDashboardStationeryTemplatesContainerQuery, CardDashboardStationeryTemplatesContainerQueryVariables>(
    CardDashboardStationeryTemplatesContainerDocument,
    baseOptions,
  );
}
export function useCardDashboardStationeryTemplatesContainerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardDashboardStationeryTemplatesContainerQuery, CardDashboardStationeryTemplatesContainerQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<CardDashboardStationeryTemplatesContainerQuery, CardDashboardStationeryTemplatesContainerQueryVariables>(
    CardDashboardStationeryTemplatesContainerDocument,
    baseOptions,
  );
}
export type CardDashboardStationeryTemplatesContainerQueryHookResult = ReturnType<typeof useCardDashboardStationeryTemplatesContainerQuery>;
export type CardDashboardStationeryTemplatesContainerLazyQueryHookResult = ReturnType<typeof useCardDashboardStationeryTemplatesContainerLazyQuery>;
export type CardDashboardStationeryTemplatesContainerQueryResult = Apollo.QueryResult<
  CardDashboardStationeryTemplatesContainerQuery,
  CardDashboardStationeryTemplatesContainerQueryVariables
>;
export const CardDashboardStationeryTemplatesSummaryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CardDashboardStationeryTemplatesSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTemplateFilter' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeOptions' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTemplateIncludeOptions' } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryTemplatesContainer' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'includeOptions' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeOptions' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagedResults' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryDesignGallerySummaryTemplate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'productIds' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryPageInfo' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryPageInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPageInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryDesignGallerySummaryTemplate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'widthInches' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heightInches' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPhoto' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCardDashboardStationeryTemplatesSummaryQuery__
 *
 * To run a query within a React component, call `useCardDashboardStationeryTemplatesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardDashboardStationeryTemplatesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardDashboardStationeryTemplatesSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      includeOptions: // value for 'includeOptions'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCardDashboardStationeryTemplatesSummaryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<CardDashboardStationeryTemplatesSummaryQuery, CardDashboardStationeryTemplatesSummaryQueryVariables>,
) {
  return ApolloReactHooks.useQuery<CardDashboardStationeryTemplatesSummaryQuery, CardDashboardStationeryTemplatesSummaryQueryVariables>(
    CardDashboardStationeryTemplatesSummaryDocument,
    baseOptions,
  );
}
export function useCardDashboardStationeryTemplatesSummaryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardDashboardStationeryTemplatesSummaryQuery, CardDashboardStationeryTemplatesSummaryQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<CardDashboardStationeryTemplatesSummaryQuery, CardDashboardStationeryTemplatesSummaryQueryVariables>(
    CardDashboardStationeryTemplatesSummaryDocument,
    baseOptions,
  );
}
export type CardDashboardStationeryTemplatesSummaryQueryHookResult = ReturnType<typeof useCardDashboardStationeryTemplatesSummaryQuery>;
export type CardDashboardStationeryTemplatesSummaryLazyQueryHookResult = ReturnType<typeof useCardDashboardStationeryTemplatesSummaryLazyQuery>;
export type CardDashboardStationeryTemplatesSummaryQueryResult = Apollo.QueryResult<
  CardDashboardStationeryTemplatesSummaryQuery,
  CardDashboardStationeryTemplatesSummaryQueryVariables
>;
export const StationeryCreateSamplePackOrderDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StationeryCreateSamplePackOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateStationerySamplePrintOrderInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAndStartCheckoutSamplePrintOrder' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'checkoutUrl' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type StationeryCreateSamplePackOrderMutationFn = Apollo.MutationFunction<StationeryCreateSamplePackOrderMutation, StationeryCreateSamplePackOrderMutationVariables>;

/**
 * __useStationeryCreateSamplePackOrderMutation__
 *
 * To run a mutation, you first call `useStationeryCreateSamplePackOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStationeryCreateSamplePackOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stationeryCreateSamplePackOrderMutation, { data, loading, error }] = useStationeryCreateSamplePackOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStationeryCreateSamplePackOrderMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<StationeryCreateSamplePackOrderMutation, StationeryCreateSamplePackOrderMutationVariables>,
) {
  return ApolloReactHooks.useMutation<StationeryCreateSamplePackOrderMutation, StationeryCreateSamplePackOrderMutationVariables>(
    StationeryCreateSamplePackOrderDocument,
    baseOptions,
  );
}
export type StationeryCreateSamplePackOrderMutationHookResult = ReturnType<typeof useStationeryCreateSamplePackOrderMutation>;
export type StationeryCreateSamplePackOrderMutationResult = Apollo.MutationResult<StationeryCreateSamplePackOrderMutation>;
export type StationeryCreateSamplePackOrderMutationOptions = Apollo.BaseMutationOptions<StationeryCreateSamplePackOrderMutation, StationeryCreateSamplePackOrderMutationVariables>;
export const StationeryIsEventEligibleForFreeSampleKitDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StationeryIsEventEligibleForFreeSampleKit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryIsEventEligibleForFreeSampleKit' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useStationeryIsEventEligibleForFreeSampleKitQuery__
 *
 * To run a query within a React component, call `useStationeryIsEventEligibleForFreeSampleKitQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeryIsEventEligibleForFreeSampleKitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeryIsEventEligibleForFreeSampleKitQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useStationeryIsEventEligibleForFreeSampleKitQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<StationeryIsEventEligibleForFreeSampleKitQuery, StationeryIsEventEligibleForFreeSampleKitQueryVariables>,
) {
  return ApolloReactHooks.useQuery<StationeryIsEventEligibleForFreeSampleKitQuery, StationeryIsEventEligibleForFreeSampleKitQueryVariables>(
    StationeryIsEventEligibleForFreeSampleKitDocument,
    baseOptions,
  );
}
export function useStationeryIsEventEligibleForFreeSampleKitLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeryIsEventEligibleForFreeSampleKitQuery, StationeryIsEventEligibleForFreeSampleKitQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<StationeryIsEventEligibleForFreeSampleKitQuery, StationeryIsEventEligibleForFreeSampleKitQueryVariables>(
    StationeryIsEventEligibleForFreeSampleKitDocument,
    baseOptions,
  );
}
export type StationeryIsEventEligibleForFreeSampleKitQueryHookResult = ReturnType<typeof useStationeryIsEventEligibleForFreeSampleKitQuery>;
export type StationeryIsEventEligibleForFreeSampleKitLazyQueryHookResult = ReturnType<typeof useStationeryIsEventEligibleForFreeSampleKitLazyQuery>;
export type StationeryIsEventEligibleForFreeSampleKitQueryResult = Apollo.QueryResult<
  StationeryIsEventEligibleForFreeSampleKitQuery,
  StationeryIsEventEligibleForFreeSampleKitQueryVariables
>;
